<template>
  <bar :data="chartData" :options="options" :ref="queryID"/>
</template>

<script>
import {Bar} from 'vue-chartjs'
import ChartHelper from "./ChartHelper"
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
ChartJS.register(ChartDataLabels)

export default {
  //  extends: Bar,
  props: ['chartType', 'queryColumns', 'queryResult', 'chartZoomResetKey', 'queryID'],
  components: {
    Bar
  },

  watch: {
    chartZoomResetKey() {
      this.$refs[this.queryID].chart.resetZoom()
    }
  },

  computed: {
    chartData() {
      if (this.queryResult && this.queryResult.length > 0) {
        let chartData = ChartHelper.buildDataset(this.chartType, this.queryColumns, this.queryResult)
        return chartData
      }
    },
    options() {
      if (this.queryResult && this.queryResult.length > 0) {
        const scaleY = ChartHelper.getScaleY(this.queryResult)
        const defaultScale = {}
        if (scaleY.min !== null) defaultScale.min = scaleY.min
        if (scaleY.max !== null) defaultScale.max = scaleY.max

        return {
          responsive: true,
          maintainAspectRatio: false,
          scaleBeginAtZero: true,

          scales: {
            x: {
              grid: {
                drawOnChartArea: false
              }
            },
            default: defaultScale,
            yRightPercent: {
              type: 'linear',
              position: 'right',
              title: {
                display: true,
                text: 'Prozent (%)'
              },
              min: 0,
              max: 100,
              stacked: false,
              ticks: {
                callback: value => value + '%'
              },
              grid: {
                drawOnChartArea: false
              }
            }
          },

          animation: {
            duration: 0
          },

          plugins: {
            legend: {
              position: 'bottom'
            },
            // Change options only for labels of THIS DATASET
/*            datalabels: this.chartData.labels.length <= 3 ? {
              align: 'end',
              anchor: 'end',

              // scriptable
              color: function (context) {
                let index = context.dataIndex;
                let value = context.dataset.data[index];
                return value < 0 ? 'darkred' :  // draw negative values in red
                  context.dataset.fontColorLabel
              },

              backgroundColor: function (context) {
                return context.dataset.backgroundColor
              },

              "padding": 5,
              "border": 0,

              font: function (context) {
                var w = context.chart.width;
                return {
                  size: w < 512 ? 12 : 14,
                  weight: 'bold',
                }
              },

              borderRadius: 1,
              borderWidth: 0,
              borderColor: 'black',
              rotation: 0,

              formatter: function (value, context) {
                return value;
              }
            } : false,*/
          }
        }
      }
    }
  }
}
</script>


<style lang="sass">

</style>
